import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { DecisionNode } from '../../../core/models/decision-tree.model';
import { AnfrageWizardStore } from '../store/anfrage-wizard.store';
import { NodeRendererInputs } from './node-renderer';

/**
 * Hint panel rendered for info_step nodes (e.g. sanitaer_haupthahn).
 * One CTA — clicking it advances the engine; any node-level autoSetUrgency
 * is applied automatically by the store.
 */
@Component({
  selector: 'app-info-step-renderer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './info-step-renderer.component.html',
  styleUrl: './info-step-renderer.component.scss',
})
export class InfoStepRendererComponent implements NodeRendererInputs {
  private readonly store = inject(AnfrageWizardStore);

  @Input({ required: true }) node!: DecisionNode;
  @Input({ required: true }) nodeKey!: string;

  acknowledge(): void {
    this.store.acknowledgeInfo();
  }
}
